<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer004">
<p class="ChapterTitle">Advance praise for <br/>boys come first</p>
<p class="Body-No-Indent ParaOverride-2">“Uproarious, sharp, bruising, hip, and real. Aaron Foley’s <span class="CharOverride-2">Boys Come First </span>moves along with a graceful self-assurance, spot-on characterizations, and a genuine assessment of the extraordinary yet mundane plight of Black queer men—how we must navigate the world, protect ourselves from violence and cruelties, construct our own safe spaces, and stitch together community from the strands of chosen family. This book is so brutally honest that it’s hard to believe it’s fiction.” </p>
<p class="Body-No-Indent ParaOverride-3">—Robert Jones Jr., author of <span class="CharOverride-2">The Prophets</span>, <br/><span class="CharOverride-2">New York Times </span>bestseller and 2021 National <br/>Book Award finalist</p>
<p class="Body-No-Indent ParaOverride-2">“Imagine the thirtysomething angst of <span class="CharOverride-2">Insecure</span> meeting the queer Black friendships of <span class="CharOverride-2">Noah’s Arc</span>, intersecting with the dating dilemmas of <span class="CharOverride-2">Waiting to Exhale</span>, all rolled up into the dynamics of a gentrified Detroit, and you’ve got <span class="CharOverride-2">Boys Come First</span>. It’s a fun novel that will have you eager to turn every page to find out what’s coming next for Dominick, Troy, and Remy.” </p>
<p class="Body-No-Indent ParaOverride-5">—Frederick Smith, author of <span class="CharOverride-2">Down for Whatever</span></p>
<p class="Body-No-Indent ParaOverride-2">“It’s all fun and games with friends Remy, Dominick, and Troy until they <br/>hit their thirties. As their fraught situationships and sexy entanglements start to reveal hard truths about themselves, the friends must deal with life’s hard questions. Foley has written a delicious romp about the game of love. But at its core, <span class="CharOverride-2">Boys Come First</span> is a laugh out loud story about Foley’s first love—<br/>the city of Detroit.”</p>
<p class="Body-No-Indent ParaOverride-6">—Desiree Cooper, Pulitzer Prize-nominated <br/>journalist and author of <span class="CharOverride-2">Know the Mother</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Boys-Epub-2.vue?163d434c